var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"purple-input",attrs:{"outline":_vm.outline,"light":_vm.light,"box":_vm.box,"value":_vm.value,"label":_vm.label,"rules":_vm.rules,"items":_vm.options,"item-disabled":function (item) { return item.disabled; }},on:{"change":function($event){return _vm.change($event)}},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('option',{style:({
        'padding-left': ((item.level) + "rem"),
      }),domProps:{"value":item.value}},[_vm._v("\n      "+_vm._s(item.text)+"\n    ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }